/**
 * These functions below are only used for development purposes and should not be used in production
 */

/**
 * Generates 3rd party GoInStore widget HTML elements and inject it inside the product page for development purposes
 * Code might change with time so needs to be reviewed, copied from the production environment and pasted in here
 */
export const generateGoInStoreWidget = (brand = 'in-store') => {
  if (typeof document !== 'undefined') {
    const goInStoreWrapper = document.createElement('div')
    goInStoreWrapper.classList.add('gis-cta-reset')
    goInStoreWrapper.innerHTML = `
      <div id="gis-connect-to-store-tab">
        <nav id="gis-cta-container" class="gis-circle gis-cta-bar-m gis-circle-right" style="background-color: transparent;">
          <div id="gis-roundel-close-button-container">
            <div id="gis-roundel-close-button" style="display: none">
              <svg viewBox="0 0 560 560">
                <circle class="cls-1" style="cursor: pointer" cx="280.5" cy="280.5" r="280.5"></circle>
                <polygon style="cursor: pointer" points="391.94 190.02 371.36 169.44 280.68 260.13 189.88 169.33 169.31 189.91 260.1 280.7 169.34 371.46 189.92 392.04 280.68 301.28 371.32 391.93 391.9 371.35 301.25 280.7 391.94 190.02"></polygon>
              </svg>
            </div>
          </div>
          <div id="gis-cta" class="gis-cta-buttons gis-cta-circle gis-cta-l gis-cta-bar-position gis-circle-animate-show" style="border-color: rgb(0, 133, 66); box-shadow: rgb(0, 133, 66) 0px 0px 0px 0px; background-size: cover;">
            <div id="gis-cta-image-container" style="display: block;">
              <div id="gis-cta-advisor-image" class="gis-cta-image">
                <style>
                  #gis-cta-advisor-image {
                    background-image:url("//gis.goinstore.com/gis/images/img/cta-logo.png?locale=en_GB&retailerToken=fd9df76f-8527-4a7e-917c-9d238a4ea3eb");
                  }
                </style>
              </div>
            <div id="gis-cta-call-icon-image" class="gis-cta-image gis-content-align gis-hide"></div>
          </div>
          <div id="gis-cta-status-container" style="display:none">
            <div id="gis-cta-live-icon" class="gis-cta-live-icon">LIVE</div>
              <div id="gis-since-live-time" class="gis-since-live-time">00:00</div>
            </div>
            <div id="gis-cta-indicator" class="gis-cta-indicator available" style="display: block; right: 0px;"></div>
          </div>
          <div id="gis-cta-bar-container" class="gis-cta-bar--container">
            <div id="gis-bar-msg-container" class="gis-cta-bar--message" style="color: rgb(255, 255, 255);">Need help? Video call a human</div>
          </div>
          <div id="gis-cta-awareness-container" style="display: flex;" class=" right gis-cta-awareness-container-l">
            <div id="gis-cta-awareness-close" class=" right">
              <svg viewBox="0 0 560 560">
                <circle class="cls-1" style="cursor: pointer; fill: rgb(0, 133, 66);" cx="280.5" cy="280.5" r="280.5"></circle>
                <polygon style="cursor: pointer; stroke: rgb(255, 255, 255); stroke-width: 30;" points="391.94 190.02 371.36 169.44 280.68 260.13 189.88 169.33 169.31 189.91 260.1 280.7 169.34 371.46 189.92 392.04 280.68 301.28 371.32 391.93 391.9 371.35 301.25 280.7 391.94 190.02"></polygon>
              </svg>
            </div>
            <div id="gis-awareness-msg-container" class=" right">
              <div style="cursor: pointer;">Video call an ${brand} expert for product advice</div>
              <div style="margin: 15px 35px 0px 0px; font-size: 16px; cursor: pointer; color: rgb(0, 133, 66);">Shop Live now</div>
            </div>
          </div>
        </nav>
      </div>
    `
    document.body.appendChild(goInStoreWrapper)
  }
}

/**
 * Appends the GoInStore 3rd party main script to the page as Tealium not enable on local development
 * @NOTE: Needs to add `?gis=2` at the end of the page URL in order to see the LG GIS widget test
 * Once the widget loaded, type `clerkIsAvailable()` on the console to enable the widget availability state
 */
export const injectGoInStoreScript = () => {
  if (typeof document !== 'undefined') {
    const goInStoreScript = document.createElement('script')
    goInStoreScript.id = 'goInStore-script-for-development'
    goInStoreScript.defer = true
    // @NOTE: Regular GIS script
    // goInStoreScript.src = '//gis.GoInstore.com/gis/script/fd9df76f-8527-4a7e-917c-9d238a4ea3eb'
    // @NOTE: LG branded GIS script
    goInStoreScript.src = '//gis.GoInstore.com/gis/script/352cee05-e457-44bc-8d4c-9156b679002f'
    document.head.appendChild(goInStoreScript)
  }
}

/**
 * Mocks the branding class to specific categories or brands
 */
export const getMockedBrandingClass = (productBrand, productCategory) => {
  let brandRelatedStyleClass

  if (productCategory && ['Sofas', 'Coffee tables', 'Table lamps', 'Desks'].includes(productCategory)) {
    switch (productCategory) {
      case 'Desks':
        brandRelatedStyleClass = 'gis-enable-product-brand-samsung'
        break
      case 'Coffee tables':
        brandRelatedStyleClass = 'gis-enable-product-brand-microsoft'
        break
      case 'Table lamps':
        brandRelatedStyleClass = 'gis-enable-product-brand-hp'
        break
      case 'Sofas':
        brandRelatedStyleClass = 'gis-enable-product-brand-lg'
        break
      default:
        brandRelatedStyleClass = ''
    }
  } else {
    switch (productBrand) {
      case 'Habitat':
      case 'Argos Home':
        brandRelatedStyleClass = 'gis-enable-product-brand-samsung'
        break
      case 'LG':
        brandRelatedStyleClass = 'gis-enable-product-brand-lg'
        break
      default:
        brandRelatedStyleClass = ''
    }
  }

  return brandRelatedStyleClass
}
